import { AppCatalogPromotionBundleService } from "../resource";

// Vuex module for variable-option promotion bundles (issue #33).
const AppCatalogPromotionBundleModule = {
    namespaced: true,
    state: {
        list: [],
        total: 0,
        loading: false,
        error: null,
        current: null
    },
    mutations: {
        SET_LIST(state, data) {
            state.list = data;
        },
        SET_TOTAL(state, total) {
            state.total = total;
        },
        SET_LOADING(state, val) {
            state.loading = val;
        },
        SET_ERROR(state, err) {
            state.error = err;
        },
        SET_CURRENT(state, item) {
            state.current = item;
        }
    },
    actions: {
        async fetchList({ commit }, params) {
            commit("SET_LOADING", true);
            commit("SET_ERROR", null);
            try {
                const res = await AppCatalogPromotionBundleService.list(params);
                const body = res.data || {};
                commit("SET_LIST", body.data || []);
                commit("SET_TOTAL", body.total || 0);
            } catch (err) {
                commit("SET_LIST", []);
                commit("SET_ERROR", err);
            } finally {
                commit("SET_LOADING", false);
            }
        },
        async fetchOne({ commit }, id) {
            commit("SET_LOADING", true);
            commit("SET_ERROR", null);
            try {
                const res = await AppCatalogPromotionBundleService.get(id);
                commit("SET_CURRENT", (res.data && res.data.data) ? res.data.data : null);
            } catch (err) {
                commit("SET_CURRENT", null);
                commit("SET_ERROR", err);
            } finally {
                commit("SET_LOADING", false);
            }
        },
        create(_, payload) {
            return AppCatalogPromotionBundleService.create(payload);
        },
        update(_, { id, payload }) {
            return AppCatalogPromotionBundleService.update(id, payload);
        },
        remove(_, id) {
            return AppCatalogPromotionBundleService.remove(id);
        },
        searchWmsProducts(_, params) {
            return AppCatalogPromotionBundleService.searchWmsProducts(params);
        },
        // ---- seller UI revamp 2026-10-03 ----
        //
        // The bundle list's slot drill-down. Same reason as the product module's
        // fetchDetail: fetchOne owns `current` and the shared `loading` flag.
        async fetchDetail(_, id) {
            const res = await AppCatalogPromotionBundleService.get(id);
            return (res && res.data && res.data.data) ? res.data.data : null;
        },
        // PATCH the status column only (spec §3 BE-3). Rejection must reach the
        // caller: the list's switch reverts on it.
        setStatus(_, { id, status }) {
            return AppCatalogPromotionBundleService.setStatus(id, status);
        }
    },
    getters: {
        list: state => state.list,
        total: state => state.total,
        loading: state => state.loading,
        error: state => state.error,
        current: state => state.current
    }
};

export default AppCatalogPromotionBundleModule;
